<template>
  <div>
    <b-row class="text-center title-subsection mr-1 mt-2">
      <p>State</p>
    </b-row>
    <MultiSelDropdownConfiguration
      id="state-dropbox"
      :controller="StateConfigCtller"
      class="ml-1"
      :disabled="!isVisibleStateReportViewer"
    />
    <b-tooltip
      v-if="!isVisibleStateReportViewer"
      target="state-dropbox"
      placement="bottom"
    >
      Requires multiple state defined on Processed data
    </b-tooltip>
  </div>
</template>

<script>
import MultiSelDropdownConfiguration from '../elements/MultiSelDropdownConfiguration'
import {multiSelComboBoxConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName, ExtraConfigKey, NameExtraConfig } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapGetters } from 'vuex'

const zoneNotify='StateSelector'
const rootContextFolder = 'ReportViewer/' + zoneNotify

export default {
  name: zoneNotify,
  components:{
    MultiSelDropdownConfiguration,
  },
  props: {
    sectionconfig:{
      type:String,
      required: true
    },
  },
  data() {
    return {
      ConfigName,
      ExtraConfigKey,
      NameExtraConfig,
      elementsConfig: [],
      StateConfigCtller: new multiSelComboBoxConfCtrller(`${ConfigName.BasePropStudy}.${ConfigName.StateTypeStudy}`,[],'State Selection','States', true, rootContextFolder),
    }
  },
  computed:mapGetters([
    'isVisibleStateReportViewer',
    'getReportStatesListReportViewer',
    'getCurrentReportViewer'
  ]),
  watch:{
    getReportStatesListReportViewer(){
      this.StateConfigCtller.options = this.getReportStatesListReportViewer
      this.StateConfigCtller.setParent(this)
      this.validateSelection();
    },
    sectionconfig(){
      this.configureStudy()
    }
  },
  mounted(){
    this.configureStudy()
    this.isVisibleReverseCurrent = typeof(this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.ReverseCurrentPresent])!=='undefined' && this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.ReverseCurrentPresent]
  },
  methods: {
    configureStudy(){
      this.elementsConfig = [
        this.StateConfigCtller,
      ]
      this.StateConfigCtller.options = this.getReportStatesListReportViewer
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.elementsConfig.forEach(conf=>conf.setParent(this))
      this.validateSelection();
    },
    validateSelection(){
      if(this.StateConfigCtller.options.length === 1){
        if(this.StateConfigCtller.value.length !== 1 || this.StateConfigCtller.value !== this.StateConfigCtller.options[0])
          this.StateConfigCtller.changeSelection([this.StateConfigCtller.options[0]]);
      }else if(this.StateConfigCtller.value[0] === 'ALL'){
        this.StateConfigCtller.changeSelection([...this.StateConfigCtller.options])
      }else{
        const selectedValid = this.StateConfigCtller.value.filter((s) => this.StateConfigCtller.options.includes(s));
        if(selectedValid.length !== this.StateConfigCtller.value.length)
          this.StateConfigCtller.changeSelection(selectedValid);
      }
    }
  }
}
</script>

<style>

</style>